import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import React, { Component } from "react";
import { Animated } from "react-animated-css";
import { Container, Row, Col } from "reactstrap";

class LilBio extends Component {
  render() {
    return (
      <Container>
        <div className="b b-- b--fw">
          <div className="b-c">
            <div className="sh ">
              <h2 className="sh-title">Testimonials</h2>
            </div>
          </div>
        </div>
        <Row>
          <Col xs="12">
            <Animated
              animationInDelay={100}
              animationIn="fadeIn"
              animationOut="fadeOut"
              isVisible
            >
              <div
                style={{ display: "inline-block" }}
                className="cd m-t500 g--4 g--4--sl"
              >
                <div
                  className="cd-ic"
                  style={{
                    backgroundImage: "url(./M.jpg)",
                    paddingBottom: "95%",
                  }}
                />
                <div className="cd-c">
                  <div className="cd-t">Lexi</div>
                  <div className="cd-d">
                    When my girl makes the perfect cake for Michaels Birthday! Funfetti
                    his fav! If you ever need cake, cupcakes or anything really get yours
                    from Ariuna @tastysinsbyari! Check her on IG
                  </div>
                </div>
              </div>

              <div
                style={{ display: "inline-block" }}
                className="cd m-t500 g--4 g--4--sl"
              >
                <div
                  className="cd-ic"
                  style={{
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundImage: "url(./12.jpg)",
                    paddingBottom: "95%",
                  }}
                />
                <div className="cd-c">
                  <div className="cd-t">Samantha</div>
                  <div className="cd-d">
                    All of my treats that I’ve ordered have been amazing . 10/10 easily .
                    I have the biggest sweet tooth and Ari makes sure that I’m a satisfied
                    customer every time , going above and beyond with every order . She’s
                    professional and Her presentation is always amazing.
                  </div>
                </div>
              </div>
              <div
                style={{ display: "inline-block" }}
                className="cd m-t500 g--4 g--4--sl"
              >
                <div
                  className="cd-ic"
                  style={{
                    backgroundImage: "url(./25.jpg)",
                    paddingBottom: "95%",
                  }}
                />{" "}
                <div className="cd-c">
                  <div className="cd-t">John</div>
                  <div className="cd-d">
                    Love, Love, Love allllll the snacks and drinks! I bought a Birthday
                    gift box for a family member and they loved it! I had to buy myself
                    some goodies too, try the Banana Pudding Cheesecake, the prices aren't
                    expensive and she had it done when expected which was nice.{" "}
                  </div>
                </div>
              </div>
              <div
                style={{ display: "inline-block" }}
                className="cd m-t500 g--4 g--4--sl"
              >
                <div
                  className="cd-ic"
                  style={{
                    backgroundImage: "url(./3.jpg)",
                    paddingBottom: "95%",
                  }}
                />{" "}
                <div className="cd-c">
                  <div className="cd-t">Brittni</div>
                  <div className="cd-d">
                    Best cakes/desserts I’ve had. She’s better than your favorite bakery
                  </div>
                </div>
              </div>
            </Animated>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default LilBio;
